import React from "react";
import Chapter from "@/components/landing/Chapter";
import Reveal from "@/components/landing/Reveal";
import PhotoFrame from "@/components/landing/PhotoFrame";
import { IMAGES } from "@/lib/landingConfig";
import { useLandingImages } from "@/lib/ImagesContext";

const Founder = () => {
  const { bySlot } = useLandingImages();
  const estherImg = bySlot["founder-esther"] || IMAGES.founderEsther;
  return (
    <section
      id="esther"
      data-testid="founder-section"
      className="bg-[#FAF8F3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="col-span-12 md:col-span-5">
            <Reveal>
              <PhotoFrame
                src={estherImg}
                alt="Esther Parejo"
                ratio="4/5"
                label="Esther Parejo"
                testId="founder-photo"
              />
            </Reveal>
            <Reveal delay={180}>
              <p className="mt-6 overline text-[#63846F]">Fundadora & Directora</p>
              <p className="mt-2 font-serif text-2xl text-[#3F403A]">Esther Parejo</p>
            </Reveal>
          </div>

          <div className="col-span-12 md:col-span-7 md:pt-4">
            <Reveal>
              <Chapter number="10" label="Sobre" />
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#3F403A]">
                Una experiencia creada y dirigida por
                <span className="italic text-[#63846F]"> Esther Parejo.</span>
              </h2>
            </Reveal>

            <div className="mt-10 space-y-6 font-sans text-base md:text-lg leading-relaxed text-[#3F403A]/85 max-w-2xl">
              <Reveal delay={120}>
                <p>
                  Esther Parejo es periodista, consultora y mentora
                  especializada en comunicación estratégica, visibilidad y
                  autoridad de marca.
                </p>
              </Reveal>
              <Reveal delay={180}>
                <p>
                  Con más de 25 años de experiencia en comunicación corporativa
                  e institucional, ha acompañado a empresas, instituciones y
                  profesionales en procesos de posicionamiento, reputación y
                  liderazgo.
                </p>
              </Reveal>
              <Reveal delay={240}>
                <p>
                  En los últimos años ha centrado su actividad en ayudar a
                  empresarias y directivas a fortalecer su capacidad de
                  influencia y convertirse en referentes visibles en sus
                  sectores.
                </p>
              </Reveal>
              <Reveal delay={300}>
                <p>
                  Es fundadora y directora de Lidera con Voz Propia, ecosistema
                  de transformación empresarial femenino que integra
                  comunicación, liderazgo, visibilidad y relacionamiento
                  estratégico.
                </p>
              </Reveal>
            </div>

            <Reveal delay={360}>
              <blockquote
                className="mt-12 md:mt-14 border-l-2 border-[#63846F] pl-6 md:pl-8 max-w-2xl"
                data-testid="founder-quote"
              >
                <p className="font-serif italic text-2xl md:text-3xl leading-snug text-[#3F403A]">
                  “Mi propósito es que más empresarias se atrevan a contarle al
                  mundo aquello que las convierte en referentes realmente
                  memorables.”
                </p>
                <footer className="mt-4 overline text-[#63846F]">— Esther Parejo</footer>
              </blockquote>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
